<!-- 机房控制 -->
<template>
    <div class='topology-box'>
        <!-- 机房控制 -->
        <div id="topology-body" style="height:100%;width:100%;padding:15px;box-sizing: border-box;">
            <div class="draw-box monition" id="drawBox" ref="drawing">
                <div id="drawing"></div>
            </div>
            <div class="option-box" style="">
                <el-button size="mini" @click="handleSetOpt('showInCenter')">居中</el-button>
                <el-button size="mini" @click="handleFullScreen">{{fullscreen?`取消全屏`:`全屏`}}</el-button>
                <template v-if="user.usertype<=3">
                    <el-button type="primary" size="mini" @click="handleAdd">监控设置</el-button>
                    <el-button type="primary" v-show="oid != ''" size="mini" @click="handleMobileSet">移动端设置</el-button>
                    <!-- <el-button type="primary" v-show="oid != ''" size="mini" @click="handlePumpSet">水泵参数设置</el-button> -->
                </template>
            </div>
            <div class="tip-box" v-if="meter_names.length>0">
                <span class="blink">{{meter_names.join('、')}}通讯中断...</span>
            </div>

            <!-- <div class="option-fullScreen" @click="handleFullScreen">
                <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                    <i class="el-icon-rank" style="font-size: 24px;"></i>
                </el-tooltip>
            </div> -->

            <!-- 弹出层 -->
            <el-dialog :title="nodeTitle" :visible.sync="dialogFormVisible" width="450px">
                <template v-for="(v, i) in node_relevanceVar">
                    <el-row :gutter="20" :key="i" style="margin-bottom:10px;">
                        <el-col :span="12">
                            {{v.var_name}}
                        </el-col>
                        <el-col :span="12">
                            {{v.var_des}}
                        </el-col>
                    </el-row>
                </template>
                <div style="height:10px;width:100%;"></div>
                <el-row :gutter="20" style="text-align:center;">
                    <el-col :span="12">
                    <el-button type="danger" size="small" :disabled="disabled" @click="handleStop('stopVal')">停止</el-button>
                    </el-col>
                    <el-col :span="12">
                    <el-button type="primary" size="small" :disabled="disabled" @click="handleStop('startVal')">启动</el-button>
                    </el-col>
                </el-row>
            </el-dialog>

            <!-- 系统控制弹框 -->
            <el-dialog :title="nodeSysTitle" :visible.sync="dialogSysVisible" width="450px">
                <el-row :gutter="20" style="text-align:center;">
                    <el-col :span="12">
                    <el-button type="danger" size="small" @click="handleSysStop(0)">停止</el-button>
                    </el-col>
                    <el-col :span="12">
                    <el-button type="primary" size="small" @click="handleSysStop(1)">启动</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
        </div>
    </div>
</template>
<script src="/static/js/svg-pan-zoom.min.js"></script>
<script>
import { mapGetters } from "vuex";
import Machine_Editor from '../machineset'
import Service from '@/api/Service'
import { $Alert, computedUtil2 } from '@/utils/utils.js'
import { fmtDoubleByte }  from '@/utils/HexToSingleBatch.js'


var Timer = {};
var DashTimer = {};
var Timer_deb = null;   //  防止ws一秒返回多次
const NODETYPE = ['GD_Z', 'GD_V','GD_H', 'GD_Z' ]
export default {
    name:  'monitoringmanna',
    data() {
        return {
            drag: null,
            dragGroup: null,
            groupZoom: null, 
            dragDefs: null,

            mySvg: null,
            scenes: null,
            scene: null, //当前场景

            currentNode: null,



            oid: '',    //  项目id
            terminalid: '',     //  表计OID

            // 弹框
            dialogFormVisible: false,
            nodeTitle: '',
            node_relevanceVar: [],
            optVar: {},

            nodeSysTitle: '',
            dialogSysVisible: false,
            sysOptVar: {},
            sysStatusVar: {},

            // 变量列表
            varData: [],
            
            nodeVarList: [],    // 存储设备节点
            pipelineList: [],   //  存储水管节点
            pumpGroup: {},  // 存储水泵组
            buttonList: [], //存储按钮节点

            ws_data: {},
			plcdata:{},
            disabled: false,        //  0点动可以控制设备，1自动不能控制设备

            fullscreen: false,
            
            meterOnline: false,
            meter_names: [],

            plcIds: [], //存储组态节点表计ID集合
            addrIds: [],    //存储节点关联地址ID集合
            id_to_addr: {
                529: 506,
                127: 505,
                126: 504
            }, //id为key，addr为值
        };
    },

    computed: {
        // 项目信息
        ...mapGetters(["WS", "ws_terminalReading", "user", "projectInfo", "machine",'projectsystemInfo']),
    },
    watch: {
        // 监听socket数据
        ws_terminalReading: {
            handler(newVal,oldVal){
                //code...业务逻辑
                this.handleData(newVal);
				this.thandleData()
            },
            immidiate:true,
            deep:true,
        }
    },
    async created() {
        this.$store.dispatch("GetProjectSystemInfo");
		this.$store.dispatch("GetProjectInfo");
        await this.getData();
        // await this.getList();
    },
    mounted() {
        let that = this;  
        this.$nextTick(()=>{
            let width = this.$refs.drawing.offsetWidth
            let height = this.$refs.drawing.offsetHeight
            
            this.drag = new SVG("drawing").size(width - 20, height - 20);
        
        })
    },
    destroyed() {
        // 关闭设备监控
        this.wsSendData("21", "[]");
        for (const key in Timer) {
            if (Timer.hasOwnProperty(key)) {
                const id = Timer[key];
                window.clearInterval(id)
            }
        }
    },
    methods: {
        getData: async function(data) {
            // 获取机房监控
            let res = await Service.getServerroombypid();
			
            if(res !== 'success') {
                this.scenes = res
                this.oid = res[0].oid;
                let scene_id = this.$route.params.id     //  场景ID
                if(scene_id != 0) {
                    let scenes = res.filter(v=>{return v.oid == scene_id})
                    this.changeSence(scenes[0])
                }else{
                    this.changeSence(this.scenes[0])
                }
            }else{
                
            }
        },
        // 切换场景
        async changeSence(v){
            let that = this;
            if(this.dragGroup !== null) {
                this.dragGroup.clear()
            }
            if(v === null || v==undefined) {
                this.dragGroup = this.drag.group()
                this.groupZoom = this.dragGroup.panZoom()
                return
            }
            
            this.scene = v;     //  存储场景内容
            let svgData = v.map_value_computer
            this.drag.svg(svgData)
            this.dragGroup = this.drag.last()
            //存储节点信息
            let nodes = this.dragGroup.children()

            let plcIds = []
            let addrIds = []
            for (let i = 0; i < nodes.length; i++) {
                const ele = nodes[i];
                let node_id = ele.node.id,
                    node_type = ele.node.dataset.type,
                    dataset = ele.node.dataset;
                if(Array.from(ele.node.classList).indexOf('e-button-group')>-1){
                    // 获取按钮path
                    if(ele.last() && ele.last().node.firstChild){
                        let tspan = ele.last().node.firstChild
                        if(tspan && tspan.nodeName === 'textPath') {
                            let id = tspan.href.baseVal.substring(1)
                            that.drag.defs().path('M0,2 150,2').attr("id", id)
                        }
                    }
                    // 过滤未绑定参数按钮
                    if(dataset.params) {
                        let params = JSON.parse(dataset.params)
                        let control_ids = params.controlList.map(v=>{return v.oid})
                        addrIds = addrIds.concat(control_ids)
                        if(params.plc_id) {
                            plcIds.push(params.plc_id)
                        }
                    }
                    this.buttonList.push({node_id, dataset})
                    continue
                }
                // 过滤未绑定地址节点
                if( dataset.type !=null && dataset.params !== undefined && dataset.params !== null){
                    // 存储设备节点
                    if(NODETYPE.indexOf(dataset.type) === -1 && dataset.type.indexOf("LINE") === -1) {
                        this.nodeVarList.push({node_id, node_type, dataset})
                        let params = JSON.parse(dataset.params)
                        let info_oid = params.device_info, opt_oid = params.opt_info, other_oids = params.other_info;
                        let arr = []
                            arr.push(info_oid, opt_oid)
                            arr = arr.concat(other_oids)
                            arr = arr.filter(v=>{return v!=''})
                        addrIds = addrIds.concat(arr)
                        if(params.plc_id) {
                            plcIds.push(params.plc_id)
                        }
                    }
                    // 存储管道节点
                    if(dataset.type.indexOf("LINE") > -1) {
                        this.pipelineList.push({node_id, node_type, dataset})
                    }
                    
                }
                if(Array.from(ele.node.classList).indexOf('pumb_group') > -1) {
                    // 获取水泵分组数据
                    this.pumpGroup = JSON.parse(dataset.params)
                }
            }
            // 去重plcID
            this.plcIds = Array.from(new Set(plcIds))
			
            this.addrIds = Array.from(new Set(addrIds))
            
            // 支持缩放
            let svg_id = this.drag.node.id
            var panZoom = window.panZoom = svgPanZoom('#' + svg_id , {
                zoomEnabled: true,
                controlIconsEnabled: true,
                fit: 1,
                center: 1,
				minZoom:0.5,
				maxZoom:5
            });
            
            window.resize = function () {
                panZoom.resize();
                panZoom.fit();
                panZoom.center();
            }
            this.drag.on('click', function(e) {
                let ele = e.target
                let node_id = ele.id,
                    node_type = ele.dataset.type,
                    dataset = ele.dataset;
                if(dataset.type != 'WARN' && NODETYPE.indexOf(dataset.type) === -1 && dataset.params !== undefined && dataset.params !== null) {
                    that.handlerOpen(JSON.parse(dataset.params))
                }
            })
            this.drag.select('g.e-button-group').on('click', function(e) {
                // 阻止事件冒泡
                e= window.event || e;
                if(document.all){  //只有ie识别
                    e.cancelBubble=true;
                }else{
                    e.stopPropagation();
                }
                let node_id = this.node.id,
                    node_type = this.node.dataset.type,
                    dataset = this.node.dataset;
                if(dataset.params !== undefined && dataset.params !== null) { 
                    if(Array.from(this.node.firstChild.classList).indexOf('btn_disabled')>-1) {
                        return
                    }
                    that.handlerContorl(JSON.parse(dataset.params))
                }
            })

            // 获取addr配置
            await this.getPlcConfig(this.addrIds)
            // 监听plc
            this.plcIds.map(v=>{
                this.ws_data[v] = {} // 初始化监听存储对象
                // this.wsSendData("20", JSON.stringify([{'oid': v + "" }]));
            })
            let arr = this.plcIds.map(v=>{return {oid: v+''}})
            this.wsSendData("20", JSON.stringify(arr));
            // this.wsSendData("20", JSON.stringify([{'oid': "274" }]));
            // 获取PLC当前数据
			for(var i = 0;i<this.plcIds.length;i++){
				await this.getMeterInfo(this.plcIds[i])
			}
            // await this.getMeterInfo(this.plcIds[0]);
        },
        async getMeterInfo(oid){
            let res = await Service.getTerminalbyidInfo({ oid })
            if(res!= 'success' && res.length>0) {
                this.checkMeterOnline(res[0])
                if(res[0].OnlineStatus !== 2) {
					var list = [{oid:JSON.stringify(oid)}]
                    this.getCurrentReading(list)
                }
            }
        },
		thandleData(){
			// this.plcIds = Array.from(new Set(this.plcIds))
			// this.plcIds.map(v =>{this.getCurrentReading(v)})
		},
        // 处理实时数据
        handleData(data) {
			var temlist = []
			this.plcIds.map(v =>{
				temlist.push({oid:JSON.stringify(v)})
			})
			this.getCurrentReading(temlist)
			// this.plcIds.map(v =>{this.getCurrentReading(v)})
			// this.getCurrentReading(this.plcIds[0])
            let that =this
            if(data.length<=0) {
                return
            }
            let newArr = data.map(v=>{
                let terminal_oid = v.terminal.OID
                this.checkMeterOnline(v.terminal)
                if(v.data.data === null) {
                    
                }else{
                    v.data.data.map(v=>{
                        for (let index = 0; index < v.bytes; index++) {
                           let addr = v.addr + index;
                           let key = JSON.stringify(addr)+ "_" + JSON.stringify(v.opcode)
                           this.ws_data[terminal_oid] ? this.ws_data[terminal_oid][key] = v.data[index] : null
                        }
                    })
                    // 防止多次重复触发
                    window.clearTimeout(Timer_deb)
                    Timer_deb = window.setTimeout(() => {
                        fn_debounce()
                    }, 2000);
                }
            })
            function fn_debounce() {
                data.map(v=>{
                    that.fmtData(v.terminal.OID)
                })
            }
        },
        // 遍历node，处理状态
        fmtData(terminal_oid) {
            let obj = this.ws_data[terminal_oid];
			let newtem = this.plcdata.filter(v=>{return v.oid == terminal_oid})
			let objarr = newtem[0].data.data
			
            /* 
                更新设备状态
                1.判断设备类型。根据设备状态值修改对应状态
            */
            this.nodeVarList.map(v=>{
                //  节点ID + 节点类型 + 节点参数 + 节点地址
                let node_id = v.node_id, 
                    node_type = v.node_type,
                    params = JSON.parse(v.dataset.params), 
                    var_addr = this.id_to_addr[params.device_info];
					let value = this.varData.filter(v=>{return v.oid == params.device_info})
					var objjdata
					for(let key  in objarr){
						//let str = JSON.stringify(var_addr)+ "_" + JSON.stringify(value[0].opcode)
                        let str = var_addr
						if(key == str){
							objjdata = objarr[key]
						}
					}
					// let objj = objarr.filter(v => {return v.addr === var_addr&&v.opcode === value[0].opcode})
					if(var_addr){
						// obj[var_addr] = objj[0].data
						obj[var_addr] = objjdata
					}
                // 是否是同一台PLC上报的数据
                if(params.plc_id === terminal_oid){
                    let ele = SVG.get(node_id)
					let addrtype = objjdata
                    switch (node_type) {
                        case 'ZJ_1':
                            if(addrtype == 1){
                                ele.load('/resources/image/l_zuji_on.png')
                            }else{
                                ele.load('/resources/image/l_zuji_off.png')
                            }
                            break;
                        case 'ZJ_2':
                            if(addrtype == 1){
                                ele.load('/resources/image/n_zuji_on.png')
                            }else{
                                ele.load('/resources/image/n_zuji_off.png')
                            }
                            break;
                        case 'LQT':
                            if(addrtype == 1){
                                ele.load('/resources/image/lengqueta.gif')
                            }else{
                                ele.load('/resources/image/lengqueta.png')
                            }
                            break;
                        case 'LQF':
                            if(addrtype == 1){
                                ele.load('/resources/image/lengquefa-on.png')
                            }else{
                                ele.load('/resources/image/lengquefa-off.png')
                            }
                            break;
                        case 'SB_1':
                            if(addrtype == 1){
                                ele.load('/resources/image/shuibeng1.gif')
                            }else{
                                ele.load('/resources/image/shuibeng1.png')
                            }
                            break;
                        case 'SB_2':
                            if(addrtype == 1){
                                ele.load('/resources/image/shuibeng2.gif')
                            }else{
                                ele.load('/resources/image/shuibeng2.png')
                            }
                            break;
                        case 'NB':
                            let value = this.varData.filter(v=>{return v.oid == params.device_info})
                            if(value.length <=0 || addrtype === undefined) return
							// let num = obj[var_addr]
							// num = computedUtil2(num, value)
							// ele.last().text(num)
                            if(value[0].bytes === 2) {
                                // 处理双字节
                                // let num = fmtDoubleByte(obj[var_addr], obj[var_addr+1])
								let num = addrtype
                                num = computedUtil2(num, value)
                                ele.last().text(num)
                                break;
                            }
                            
                            if(value[0].var_type == 1 || value[0].var_type == 5) {
                                let text = computedUtil2(addrtype, value)
                                ele.last().text(text)
                            } else {
                                // bool类型
                                if(addrtype == 1) {
                                    ele.last().text(value[0].var_1_represent)
                                } else {
                                    ele.last().text(value[0].var_0_represent)
                                }
                            }
                            break;
                        case 'WARN': 
                            if(addrtype == 1){
                                ele.attr('class', 'e_device')
                                ele.load('/resources/image/reddot.gif')
                            }else{
                                ele.attr('class', 'e_device e_warn')
                                ele.load('/resources/image/reddot.png')
                            }
                            break;
                        default:
                            break;
                    }
                }
            })

            /* 
                更新水流状态
                1.判断水泵组
                2.判断水流关联设备
                3.最后1&&2判断结果
            */

            let BOOL = {}
            if(JSON.stringify(this.pumpGroup) !== "{}") {
                this.pumpGroup.pumpTab.map(v=>{
                    if(v.plc_id === terminal_oid){
                        BOOL[Number(v.index)] = false;
                        let pumpList = this.pumpGroup.pumpList[Number(v.index)]
                        pumpList.map(v1=>{
                            let addr = this.id_to_addr[v1.oid];
                            if(this.ws_data[terminal_oid][addr] == v1.value) {
                                BOOL[Number(v.index)] = true
                            }
                        })
                    }
                })
            }
            
            this.pipelineList.map(v=>{
                
                let node = SVG.get(v.node_id)
                let params = JSON.parse(v.dataset.params)
                
                let pumpGroup = params.pumpGroup
                let directionLine = params.directionLine
                let condition_bool = false
                if(params.condition.length === 0) { // 主管道
                    condition_bool = true
                }

                let pumpTab = this.pumpGroup.pumpTab.filter(v=>{return v.index === pumpGroup})[0]   //  管道对应水泵组
                
                if(pumpTab && pumpTab.plc_id === terminal_oid) {    //  水泵组PLC_ID跟上报PLC_ID相同
                    params.condition.map(v=>{   // 管道关联设备组
                        if(!!v.addr){
                            let addr = this.id_to_addr[v.addr];
                            if(this.ws_data[terminal_oid][addr] === Number(v.value)) {
                                condition_bool = true
                            }
                        }
                    })
                    if(BOOL[Number(pumpGroup)] && condition_bool) {   //  水泵ture + 管道关联设备组true
                        if(!node.hasClass(directionLine)) {
                            node.addClass(directionLine)
                        }
                    }else{  //  水泵组关
                        if(node.hasClass(directionLine)) {
                            node.removeClass(directionLine)
                        }
                    }
                }else{
                    
                }
                
            })
            // 修改按钮样式
            this.buttonList.map(v=>{
                if(!v.dataset.params) return
                let node_id = v.node_id, 
                    node_type = v.node_type,
                    params = JSON.parse(v.dataset.params);
                if(params.type === "control"){
                    // 单点控制
                    if(params.controlList.length===1) {
                         let objss = this.ws_data[terminal_oid];
                         console.log(objss)
                        let oid = params.controlList[0].oid
                        let val = params.controlList[0].value
                        let addr = this.id_to_addr[oid];
                        let ele = SVG.get(node_id).first()
                        if(this.ws_data[terminal_oid][addr] == Number(val)) {
                            ele.fill("#266cba").addClass("btn_disabled")
                        }else{
                            ele.fill("#999").removeClass("btn_disabled")
                        }
                    }else{
                        // 群控

                    }
                    
                }
            })
            
            this.disabled = this.ws_data[terminal_oid][2] === 1; //  自动模式1 不能控制

            return
        },
        handleAdd() {
            let id = this.$route.params.id
            window.open("/machineEditor")
            // this.$router.push("/machineEditor")
        },
        handleMobileSet(){
            let oid = this.oid || 0;
            this.$router.push("/machinemana/mobile/" + oid)  
        },

        handlePumpSet() {
            this.$router.push("/pumpsetting/pumpsetting")  
        },
        // 获取PLC当前数据
        async getCurrentReading(v){
            let res = await Service.getmorePlcCurrentReadings({terminalidlist:JSON.stringify(v)});
            if(res){
                let data = res || []
				this.plcdata = res
                data.map(v=>{
					var oid=v.oid
					var newdata = v.data.data
					
					for(let key  in newdata){
						this.ws_data[oid] ? this.ws_data[oid][key] = newdata[key] : null
					}
                    this.fmtData(oid)
                })
            }
        },
        // 判断PLC 是否在线
        checkMeterOnline(data) {
            if(data.OnlineStatus === 2) {
                if(this.meter_names.indexOf(data.customized_serial) === -1) {
                    this.meter_names.push(data.customized_serial)
                }
            }else{
                let index = this.meter_names.indexOf(data.customized_serial)
                if (index !== -1) {
                    this.meter_names.splice(index, 1)
                }
            }
        },
        // 获取变量列表
        async getPlcConfig(addrIds) {
			if(addrIds[0].collector_id){
			}else{
					let id_list = addrIds.map(v=>{return {oid: v}})
					let res = await Service.getPlcConfiguration({id_list: JSON.stringify(id_list)});
					if(res != 'success' && res.length>0) {
						let obj = {}
						res.map(v=>{
							//obj[v.oid] = v.var_Initial_addr
                            obj[v.oid] = JSON.stringify(v.var_Initial_addr)+ "_" + JSON.stringify(v.opcode)
						})
						this.id_to_addr = obj;
						this.varData = res;
					}
			}
        },

        // 发送websocket
        wsSendData(type, ids){
            let userid = this.user.oid + "";
            let assigned_project_id = this.projectsystemInfo.oid + "";
            let sendtype = type;
            let monitortidlist = ids;
            if(this.WS && this.WS.$alive) {
                this.WS.send(JSON.stringify({userid, assigned_project_id, sendtype, monitortidlist}))
            }
        },

        // 弹框展示信息
        handlerOpen(params) {
            // 相关参数
            let optOid = params.opt_info
            let { startVal, stopVal, plc_id } = params

            let otherAddr = params.other_info;
            
            let relevanceArr = otherAddr.map(v=>{
                let value = this.varData.filter(v1=>{return v1.oid == v})

                // let obj = this.ws_data[plc_id]
				//let objarr = this.plcdata
				//let obj = objarr.filter(v => {return v.opcode === value[0].opcode && v.addr === value[0].var_Initial_addr})
                //let obj = objarr.filter(v => {return v.opcode === value[0].var_Initial_addr+"_"+value[0].opcode})
                let newtem = this.plcdata.filter(v=>{return v.oid == plc_id})
                let objarr = newtem[0].data.data
                let strkey = JSON.stringify(value[0].var_Initial_addr)+ "_" + JSON.stringify(value[0].opcode)
                
                    let var_name = value[0].var_name
                    // let addr = value[0].var_Initial_addr
                    let var_des = ''
                    if(value[0].bytes === 2) {
                        // 处理双字节
                        // let num = fmtDoubleByte(obj[addr], obj[addr+1])
                        //let num = obj[0].data
                        let num = objarr[strkey]
                        num = computedUtil2(num, value)
                        var_des = num + ' / '+ value[0].unit
                        
                    }else{
                        if(value[0].var_type == 1 || value[0].var_type == 5) {
                            let text = computedUtil2(objarr[strkey], value)
                            var_des = text + ' / '+ value[0].unit
                        } else {
                            // bool类型
                            if(objarr[strkey] == 1) {
                                var_des = value[0].var_1_represent
                            } else {
                                var_des = value[0].var_0_represent
                            }
                        }
                    }
                
                return Object.assign({},{var_name, var_des})
            })
            
            this.node_relevanceVar = relevanceArr
            // 弹框按钮
            
            this.optVar = Object.assign({}, { startVal, stopVal, optOid, plc_id })
            this.dialogFormVisible = true;
        },
        // 设备启动+停止
        handleStop(type) {
            let oid = this.optVar.optOid
            let plc_id = this.optVar.plc_id
            let value = this.varData.filter(v1=>{return v1.oid == oid})
            if(value && value.length>0) {
                this.controlServer(value[0], this.optVar[type], plc_id);
            }
        },
        // 按钮控制
        handlerContorl(params) {
            let ctr_type = params.type

            if(ctr_type === 'control') {
                // 控制
                let controlList = params.controlList
                let plc_id = params.plc_id
                // if(controlList.length<=0) return
                $Alert(`是否确认控制`).then((bool)=>{
                    if(bool){
                        // 递归发送请求
                        let that = this, index = 0;
                        async function request() {
                            if(index >= controlList.length) return
                            let v = controlList[index]
                            let value = that.varData.filter(v1=>{return v1.oid == v.oid})
                            if(value && value.length>0) {
                                await that.controlServer(value[0], v.value, plc_id);
                                index++
                                request()
                            }
                        }
                        request()
                        // controlList.map(async v=>{
                        //     let value = this.varData.filter(v1=>{return v1.var_Initial_addr == v.addr})
                        //     if(value && value.length>0) {
                        //         await this.controlServer(value[0], v.value);
                        //     }
                        // })
                    }
                });
            }else if(ctr_type === 'skipScene'){
                // 跳转场景
                let id = params.scene_id
                if(!id) return
                this.$router.push('/machinemana/' + id)
            }else{
                
            }
            
            
        },
        
        // 控制
        async controlServer(opt, type, plc_id) {
            let data = {};
            let opcode
            if(opt.opcode == 1) {
                opcode = 5
            };
            if(opt.opcode == 3) {
                opcode = 6
            }
            data.terminalid = plc_id;
            data.opcode = opcode;
            data.addrstart = opt.var_Initial_addr
            // data.bytes = 1;
            data.value = Number(type);
            let res = await Service.controlPlcinteraction(data);
            if(res) {
                this.$message({
                    type: 'success',
                    message: '发送成功!'
                });
                this.dialogFormVisible = false;
                this.dialogSysVisible = false;
            }
            this.upDataDevice(plc_id, opt.var_Initial_addr)
        },

        upDataDevice(plc_id, addr) {
            let data = {};
            data.terminalid = plc_id;
            data.opcode = 1;
            data.addrstart = addr;
            setTimeout(() => {
                Service.controlPlcinteraction(data);
            }, 3000);
        },

        // 工具栏
        handleSetOpt(type) {
            if(type === 'showInCenter') {
                panZoom.resize();
                panZoom.fit();
                panZoom.center();
            }
        },
        // 全屏事件
        handleFullScreen(){
            let element = document.getElementById("topology-body");
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
            
            // 机房监控页面
            setTimeout(() => {
                let width = this.$refs.drawing.offsetWidth
                let height = this.$refs.drawing.offsetHeight
                this.drag.size(width - 20, height - 20)
                panZoom.resize();
                panZoom.fit();
                panZoom.center();
            }, 1000);
        },
    }
}

</script>
<style lang='less' scoped>
.topology-box{
    height: calc(100% - 26px);
    width:100%;
    position: relative;
}
.option-box{
    position: absolute;
    z-index: 99;
    left: 20px;
    right: 20px;
    top: 20px;
    height: 40px;
    line-height: 40px;
}
.option-fullScreen{
    position: absolute;
    z-index: 99;
    right: 20px;
    top: 20px;
}

.tip-box{
    position: absolute;
    z-index: 1000;
    left: 20px;
    right: 20px;
    top: 50px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: red;
    font-size: 20px;
}
/* 定义keyframe动画，命名为blink */
@keyframes blink{
    0%{opacity: 1;}
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100%{opacity: 0;} 
}
/* 添加兼容性前缀 */
@-webkit-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
@-moz-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
@-ms-keyframes blink {
    0% {opacity: 1; } 
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0;}
}
@-o-keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 1; }
    50.01% { opacity: 0; }
    100% { opacity: 0; }
}
/* 定义blink类*/
.blink{
    animation: blink 1s linear infinite;  
    /* 其它浏览器兼容性前缀 */
    -webkit-animation: blink 1s linear infinite;
    -moz-animation: blink 1s linear infinite;
    -ms-animation: blink 1s linear infinite;
    -o-animation: blink 1s linear infinite;
}

.draw-box{
    height: 100%;
    width: 100%;
    background-color: #f5f5f5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    // background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDQgTCAxNiA0IE0gNCAwIEwgNCAxNiBNIDAgOCBMIDE2IDggTSA4IDAgTCA4IDE2IE0gMCAxMiBMIDE2IDEyIE0gMTIgMCBMIDEyIDE2IiBmaWxsPSJub25lIiBzdHJva2U9IiNlMGUwZTAiIG9wYWNpdHk9IjAuMiIgc3Ryb2tlLXdpZHRoPSIxIi8+PHBhdGggZD0iTSAxNiAwIEwgMCAwIDAgMTYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2UwZTBlMCIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+")
}
</style>